import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { InternshipDetailsModel } from 'common/models/page-models/internship-detail/internship-detail-data.model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { InternshipDetailsFormWidgetService } from 'common/widget/Internship-details/internship-details-form-widget.service';
import { WidgetModel } from 'common/models/utility-models/base-model';
import { StudentAvailabilityModel } from 'common/models/page-models/internship-detail/student-availability-data.model';
import { InternshipDetailsMetaModel } from 'common/models/page-models/internship-detail/internship-detail-form-meta.model';



@Injectable({
    providedIn: 'root'
})
export class InternshipDetailsFormResolver extends FormResolverService<InternshipDetailsModel> {
    constructor(
        protected fs: InternshipDetailsFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override initWidget(envelopeType: any, transferData: any): WidgetModel {
        const widget = new WidgetModel();
        transferData.formData = new StudentAvailabilityModel();
        transferData.formMeta = new InternshipDetailsMetaModel().getMetaModel();
        // this.fs.getFilterOptions(transferData.filterMeta);
        widget.transferData = transferData;
        return widget;
    }
}
